import * as React from 'react';
import { connect } from 'react-redux';

import { DailyFormsModel } from '../../../model/DailyFormModel';
import { getDailyFormDetails } from '../../../services/dailyFormService';
import { DetailsPageWrapper } from '../../reusableComponents/DetailsPageWrapper';

export interface IDetailsPageProps {
    id: string;
    instance: DailyFormsModel;
}

export class DetailsPageImpl extends React.PureComponent<IDetailsPageProps, {}> {

    static defaultProps: IDetailsPageProps;

    promise = async () => {
        await getDailyFormDetails(this.props.id);
    }

    render() {
        return (
            <DetailsPageWrapper
                id=""
                pageTitle={this.props.instance ? this.props.instance.props.type.toLowerCase() === 'dailyform' 
                ? `Daily Form Details ${this.props.instance.props.Date}` : `${this.props.instance.props.type} Form Details ${this.props.instance.props.Date}` : 'Daily Form'}
                backTo="daily"
                formType="daily"
                instance={this.props.instance}
                promise={this.promise}
            />
        );
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const instance = DailyFormsModel.get(id); 
    return {
        instance, id
    };
}

export const DetailsPage = connect<{}, {}, IDetailsPageProps>(mapStateToProps)(DetailsPageImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Daily/DetailsPage.tsx